import { Alert, Button, ButtonProps, Snackbar, styled } from '@mui/material';
import { RiClipboardLine } from '@remixicon/react';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';



interface FlashButtonProps {
    flashgreen: string;
}

const FlashButton = styled(Button)<FlashButtonProps>(({ theme, flashgreen }) => ({
    backgroundColor: flashgreen == "true" ? 'green' : '',
    transition: 'background-color 0.3s',
    '&:hover': {
        backgroundColor: flashgreen ? '#687864' : theme.palette.primary.main,
    },
}));

interface GaneshCopyToClipboardProps extends ButtonProps {
    textToCopy: string;
    showButtonText?: boolean;
    buttonText?: string;
    alertLabel?: string;
}

const GaneshCopyToClipboardBtn: React.FC<GaneshCopyToClipboardProps> = ({ textToCopy, showButtonText, buttonText, alertLabel, ...props }) => {


    const [copied, setCopied] = useState(false);
    const [flashGreen, setFlashGreen] = useState<boolean>(false);

    const handleCopy = (type: string) => {
        setCopied(true);
        setFlashGreen(true);


        setTimeout(() => {
            setFlashGreen(false);
            setCopied(false);
        }, 1000);
    };


    return (<>
        <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
            <FlashButton
                variant={props.variant ?? "contained"}
                color={props.color ?? "primary"}
                size={props.size ?? "medium"}
                startIcon={showButtonText ? props.startIcon ?? <RiClipboardLine /> : ""}
                flashgreen={flashGreen.toString()}
                disabled={!textToCopy}
                {...props}
                sx={{
                    ...props.sx
                }}
            >
                {showButtonText ? buttonText ?? "Copy to Clipboard" : props.startIcon ?? <RiClipboardLine />}
            </FlashButton>
        </CopyToClipboard>
        <Snackbar
            open={copied}
            autoHideDuration={1000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            <Alert severity="success" sx={{ width: '100%' }}>
                {alertLabel ? `Copied ${alertLabel}!` : "Copied!"}
            </Alert>
        </Snackbar>
    </>
    );
}

export default GaneshCopyToClipboardBtn;
